/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../../../components/Grid/Grid';
import Typography from '../../../../components/Typography/Typography';

/**
 * SinteringDetailResultMetadata 元件顯示燒結檢驗的結果元資料，包含檢測備註與人工檢測結果。
 *
 * @component
 * @param {Object} props - 元件屬性
 * @param {Object} props.resultMetadata - 結果元資料物件
 * @param {string} props.resultMetadata.comment - 檢測備註
 * @param {boolean|null} props.resultMetadata.isManualPass - 人工檢測結果，null表示未設定，true表示通過，false表示不通過
 * @returns {JSX.Element}
 */

const SinteringDetailResultMetadata = ({ resultMetadata }) => (
  <Grid container direction="column" gap={1} sx={{ mt: 2 }}>
    <Grid item container gap={1}>
      <Grid item>
        <Typography variant="body1">檢測備註：</Typography>
      </Grid>
      <Grid item>
        <Typography variant="body1">{resultMetadata.comment || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid item container>
      <Grid item gap={1} container>
        <Typography variant="body1">人工檢測結果：</Typography>
        {resultMetadata.isManualPass === null ? (
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            -
          </Typography>
        ) : (
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              color: resultMetadata.isManualPass ? 'secondary.main' : 'error.main',
            }}
          >
            {resultMetadata.isManualPass ? '通過' : '不通過'}
          </Typography>
        )}
      </Grid>
    </Grid>
  </Grid>
);

SinteringDetailResultMetadata.propTypes = {
  resultMetadata: PropTypes.object.isRequired,
};

export default SinteringDetailResultMetadata;
